import React, { Component } from "react";
import {Table,Steps,Message} from "element-react";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";

import "./index.scss"

export default class Index extends Component{
    constructor(props){
        super(props)
        this.state={
            columns:[
                {
                    label:'环节',
                    prop:'linkName',
                    width:60,
                    fixed:'left',
                    align:'center',
                },
                {
                    label:'办理人员',
                    prop:'handlingPersonnel',
                    width:100,
                    align:'right',
                },
                {
                    label:'办理时限',
                    prop:'handlingTime',
                    width:80,
                    align:'right',
                },
                {
                    label:'审查标准',
                    prop:'reviewCriteria',
                    width:120,
                    align:'right',
                },
                {
                    label:'办理结果',
                    prop:'handlingResults',
                    minWidth:160,
                    flex:1,
                    align:'right',
                },
                {
                    label:'是否存在特殊环节',
                    prop:'specialLinkStatus',
                    width:100,
                    align:'right',
                    render(text,item){
                        if(text.specialLinkStatus == '0'){
                            return '否'
                        }else{
                            return '是'
                        }
                    }
                },


            ],
            data:[
                {   
                    people:'旗县退役军人服务中心',
                    time:'无',
                    link:'受理',
                    standard:'1.申请材料是否齐全、是否符合法定形式。',
                    result:'无',
                    condition:'是'
                },
                {   
                    people:'旗县退役军人服务中心',
                    time:'无',
                    link:'审查',
                    standard:'1.申请材料是否齐全、是否符合法定形式。',
                    result:'无',
                    condition:'否'
                },
                {   
                    people:'旗县退役军人服务中心',
                    time:'无',
                    link:'决定',
                    standard:'1.申请材料是否齐全、是否符合法定形式。',
                    result:'无',
                    condition:'否'
                },
            ],
            columns2:[
                {
                    label:'材料名称',
                    prop:'materialName',
                    width:120,
                    fixed:'left',
                    align:'center',
                },
                {
                    label:'材料形式',
                    prop:'materialForm',
                    width:80,
                    align:'center',
                },
                {
                    label:'来源渠道',
                    prop:'sourceChannel',
                    width:80,
                    align:'center',
                },
                {
                    label:'纸质材料份数',
                    prop:'number',
                    width:80,
                    align:'center',
                },
                {
                    label:'填报需知',
                    prop:'describe',
                    // width:120,
                    flex:1, 
                    align:'center',
                },
                {
                    label:'必要性',
                    prop:'necessity',
                    width:80,
                    align:'center',
                },
                {
                    label:'受理标准',
                    prop:'acceptanceConditions',
                    width:80,
                    align:'center',
                },
                {
                    label:'样表下载',
                    prop:'download',
                    width:80,
                    align:'center',
                    emptyText:'暂无下载'
                },
            ],
            data2:[
                {   shape:'纸质',
                    source:'其他',
                    num:1,
                    name:'预备役登记证明（入伍地人民武装部办理）',
                    know:'原件',
                    necessity:'必要',
                    standard:'无',
                    download:'暂无下载'
                },
                {   shape:'纸质',
                    source:'其他',
                    num:1,
                    name:'入伍通知书',
                    know:'原件和复印件',
                    necessity:'必要',
                    standard:'无',
                    download:'暂无下载'
                },
                {   shape:'纸质',
                    source:'政府部门核发',
                    num:1,
                    name:'户口本',
                    know:'原件和复印件',
                    necessity:'必要',
                    standard:'无',
                    download:'暂无下载'
                },
                    {shape:'纸质',
                    source:'政府部门核发',
                    num:1,
                    name:'身份证',
                    know:'原件和复印件',
                    necessity:'必要',
                    standard:'无',
                    download:'暂无下载'
                },
                {   shape:'纸质',
                    source:'其他',
                    num:1,
                    name:'士官退出现役证',
                    know:'原件和复印件',
                    necessity:'必要',
                    standard:'无',
                    download:'暂无下载'
                },
                {   shape:'纸质',
                    source:'其他',
                    num:1,
                    name:'部队行政介绍信',
                    know:'原件和复印件',
                    necessity:'必要',
                    standard:'无',
                    download:'暂无下载'
                },
            ],
            Info:[
                {name:'事项名称',info:'退役士兵安置'},
                {name:'基本编码',info:'000000'},
                {name:'实施主体',info:'旗县退役军人服务中心'},
                {name:'实施主体性质',info:'法定机关'},
                {name:'事项类型',info:'行政给付'},
                {name:'服务对象',info:'自然人'},
                {name:'是否网办',info:'否'},
                {name:'事项状态',info:'启用'},
                {name:'数量限制',info:'无'},
                {name:'权力来源',info:'法定本级行使'},
                {name:'审批结果名称',info:'退役士兵安置'},
                {name:'审批结果样本',info:'无'},
                {name:'网上办理深度',info:'信息发布（1级）'},
                {name:'是否支持网上支付',info:'否'},
                {name:'是否支持预约办理',info:'否'},
                {name:'是否进驻政务大厅',info:'否'},
                {name:'移动端是否对接单点登录',info:'否'},
                {name:'计算机端是否对接单点登录',info:'否'},
                {name:'是否支持物流快递',info:'否'},
                {name:'是否支持自助终端办理',info:'否'},
                {name:'移动端办理地址',info:'无'},
                {name:'计算机端在线办理跳转地址',info:'无'},
                {name:'审批结果类型',info:'无'},
                {name:'行使层级',info:'自治区、市级、旗县区'},
                {name:'实施编码',info:'000000'},
                {name:'实施主体编码',info:'000000'},
                {name:'联办机构',info:'无'},
                {name:'办件类型',info:'承诺件'},
                {name:'办理形式',info:'线下办理'},
                {name:'是收费',info:'否'},
                {name:'中介服务',info:'否'},
                {name:'事项版本',info:'无'},
                {name:'通办范围',info:'无'},
            ],
            Info2:[],
            data3:[],
            data4:[],
            flag:false,
        }
    }
    componentDidMount(){
        // this.getList()
        this.getInfo()
    }
    getInfo = () =>{
        console.log(window.location.search.split('=')[1])
        let id = window.location.search.split('=')[1]
        if(!id){
            Message.error('暂无数据')
        }
        let params = {
            id
        }
        Http.get(Request.getInfo(),params,obj=>{
            if(obj.code == 200){
                this.setState({
                    Info2:obj.data.itemInformationVO,
                    data3:obj.data.itemInformationVO.itemHandlingProcessVOList,
                    data4:obj.data.itemInformationVO.itemApplyMaterialsVOList
                },()=>{
                    console.log(this.state.Info2)
                })
            }
        })
    }
    open = ()=>{
        const {flag} = this.state
        console.log(11111)
        console.log(flag)
        if(flag){
            this.setState({
                flag:false
            })
        }else{
            this.setState({
                flag:true
            })
        }
    }
    getList=()=>{
        this.state.Info.map(item=>{
            console.log(`<li><i>${item.name}:</i> <em></em></li>`)
        })
    }
    goback = () =>{
        window.history.back()
    }


 



    render(){
        const {Info2} = this.state
        return(
            <div className="box">
                {/* <div className="header">
                    <span><i className="el-icon-arrow-left" onClick={this.goback}></i><h2>退役士兵安置</h2>(退役安置)</span>
                </div> */}
                <div className="m_main">
                    <div className="content6 com">
                        <div className="title">
                            <div></div>
                            <h2>基本信息</h2>
                        </div>
                        <div className={this.state.flag ? '' : 'info'} >
                            <ol>
                                {/* {
                                    this.state.Info.map(item=>{
                                        return(<li><i>{item.name}:</i> <em>{item.info}</em></li>)
                                    })
                                } */}
                                   <li><i>事项名称：</i> <em>{Info2.itemName}</em></li>
                                    <li><i>基本编码：</i> <em>{Info2.baseCode ? Info2.baseCode : '无'}</em></li>
                                    <li><i>实施主体：</i> <em>{Info2.implementMainstay}</em></li>
                                    <li><i>实施主体性质：</i> <em>{Info2.implementMainstayNature}</em></li>
                                    <li><i>事项类型：</i> <em>{Info2.itemType}</em></li>
                                    <li><i>服务对象：</i> <em>{Info2.serviceObject}</em></li>
                                    <li><i>是否网办：</i> <em>{Info2.networkOfficenStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>事项状态：</i> <em>{Info2.itemStatus == '0' ? '停用' : '启用'}</em></li>
                                    <li><i>数量限制：</i> <em>{Info2.numberLimit}</em></li>
                                    <li><i>权力来源：</i> <em>{Info2.powerSource}</em></li>
                                    <li><i>审批结果名称：</i> <em>{Info2.approvalResultName}</em></li>
                                    <li><i>审批结果样本：</i> <em>{Info2.approvalResultSample}</em></li>
                                    <li><i>网上办理深度：</i> <em>{Info2.networkOfficenDepth}</em></li>
                                    <li><i>是否支持网上支付：</i> <em>{Info2.onlinePaymentStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>是否支持预约办理：</i> <em>{Info2.bookingStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>是否进驻政务大厅：</i> <em>{Info2.governmentHallStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>移动端是否对接单点登录：</i> <em>{Info2.appSingleSignonStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>计算机端是否对接单点登录：</i> <em>{Info2.pcSingleSignonStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>是否支持物流快递：</i> <em>{Info2.logisticsExpressStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>是否支持自助终端办理：</i> <em>{Info2.terminalStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>移动端办理地址：</i> <em>{Info2.appAddress}</em></li>
                                    <li><i>计算机端在线办理跳转地址：</i> <em>{Info2.pcAddress}</em></li>
                                    <li><i>审批结果类型：</i> <em>{Info2.approvalResultType}</em></li>
                                    <li><i>行使层级：</i> <em>{Info2.exerciseHierarchy}</em></li>
                                    <li><i>实施编码：</i> <em>{Info2.implementCode ? Info2.implementCode : '无'}</em></li>
                                    <li><i>实施主体编码：</i> <em>{Info2.implementMainstayCode ? Info2.implementMainstayCode : '无'}</em></li>
                                    <li><i>联办机构：</i> <em>{Info2.jointOrganization}</em></li>
                                    <li><i>办件类型：</i> <em>{Info2.workType}</em></li>
                                    <li><i>办理形式：</i> <em>{Info2.processingType}</em></li>
                                    <li><i>是否收费：</i> <em>{Info2.chargeStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>中介服务：</i> <em>{Info2.intermediaryServicesStatus == '0' ? '否' : '是'}</em></li>
                                    <li><i>事项版本：</i> <em>{Info2.itemEdition}</em></li>
                                    <li><i>通办范围：</i> <em>{Info2.tongbanRange}</em></li>
                            </ol>
                        </div>
                        <hr />
                        <div className="drawer" onClick={this.open}>{this.state.flag ? <span>收起<i className="el-icon-arrow-up"></i></span>  : <span>展开<i className="el-icon-arrow-down"></i></span>}</div>
                    </div>
                    <div className="content7 com">
                        <div className="title">
                            <div></div>
                            <h2>受理条件</h2>
                        </div>
                        <div className="condition">
                            {Info2.acceptanceConditions}
                        </div>
                    </div>
                    <div className="content8 com" >
                        <div className="title">
                            <div></div>
                            <h2>设定依据</h2>
                        </div>
                        <div className="rule">
                        {Info2.settingBasis}
                        </div>
                    </div>
                    <div className="content1 com">
                        <div className="title">
                            <div></div>
                            <h2>收费标准和依据</h2>
                        </div>
                        <div className="rates">
                            {Info2.chargingStandardBasis}
                        </div>
                    </div>
                    <div className="content2 com">
                        <div className="title">
                            <div></div>
                            <h2>办理流程</h2>
                        </div>
                        <div className="flow">
                            <div className="flow_top">
                                <Steps width={100} active={1}>
                                    <Steps.Step title="受理" ></Steps.Step>
                                    <Steps.Step title="审查" ></Steps.Step>
                                    <Steps.Step title="决定" ></Steps.Step>
                                </Steps>
                            </div>
                            <Table
                                style={{width: '100%'}}
                                columns={this.state.columns}
                                data={this.state.data3}
                                border={true}
                                />
                        </div>
                    </div>
                    <div className="content3 com">
                        <div className="title">
                                <div></div>
                                <h2>申请材料</h2>
                            </div>
                        <div className="materials">
                            <Table 
                            style={{width: '100%'}}
                            columns={this.state.columns2}
                            data={this.state.data4}
                            border={true}
                            />
                        </div>
                    </div>
                    <div className="content4 com ">
                        <div className="title">
                            <div></div>
                            <h2>办理地点</h2>
                        </div>
                        <div className="site">
                            <ul>
                                <li><i>办理地点：</i> <em>{Info2.implementMainstay}</em></li>
                                <li><i>办理时间：</i> <em>{Info2.processingTime}</em></li>
                                {/* <li><i>公交路线：</i> <em>{Info2.busRoutes}</em></li> */}
                            </ul>
                        </div>  
                    </div>
                    <div className="content5 com">
                        <div className="title">
                            <div></div>
                            <h2>常见问题</h2>
                        </div>
                        <div className="problem">
                            暂无
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}